const NAME = "HISTORIC_ACCUMULATORS";

export default NAME;
